<template>
  <div id="app-container">
    <nprogress-container></nprogress-container>
    <router-view :key="$route.fullPath" />
    <splash-screen />
    <div
      v-if="updateAvailable"
      class="pwa-update-banner"
      role="button"
      tabindex="0"
      @click="refreshApp"
      @keydown.enter="refreshApp"
    >
      {{ $t("pwa_update_available") }}
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import SplashScreen from "@/components/mylogy/SplashScreen.vue";
import NprogressContainer from "vue-nprogress/src/NprogressContainer";

export default {
  name: "App",
  components: { SplashScreen, NprogressContainer },
  data() {
    return {
      deferredPrompt: null,
      updateAvailable: false,
      swRegistration: null,
      refreshing: false
    };
  },

  methods: {
    async dismiss() {
      Cookies.set("add-to-home-screen", null, { expires: 15 });
      this.deferredPrompt = null;
    },
    async install() {
      this.deferredPrompt.prompt();
    },
    onSwUpdated(event) {
      this.swRegistration = event.detail;
      this.updateAvailable = true;
    },
    refreshApp() {
      if (this.refreshing) {
        return;
      }
      this.refreshing = true;

      const registration = this.swRegistration;
      if (registration && registration.waiting) {
        registration.waiting.postMessage({ type: "SKIP_WAITING" });
        return;
      }

      window.location.reload();
    }
  },
  created() {
    document.addEventListener("swUpdated", this.onSwUpdated, { once: true });
    navigator.serviceWorker &&
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (this.refreshing) {
          window.location.reload();
        }
      });
  },
  beforeDestroy() {
    document.removeEventListener("swUpdated", this.onSwUpdated);
  },
  mounted() {
    this.$store.commit("app/SET_SITE_URL", process.env.VUE_APP_SITE_URL);
  }
};
</script>

<style>
.pwa-update-banner {
  position: fixed;
  left: 16px;
  right: 16px;
  bottom: 16px;
  z-index: 10000;
  padding: 14px 18px;
  border-radius: 10px;
  background: #1c093a;
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  cursor: pointer;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.28);
  text-decoration: underline;
}

.pwa-update-banner:hover,
.pwa-update-banner:focus {
  background: #2a1058;
  outline: none;
}

.hide-content {
  filter: blur(0.2rem);
}
select[name="sort-options"] {
  display: none;
}

#nprogress .bar {
  background: #6ffcbc;

  position: fixed;
  z-index: 1031;
  top: 0;
  left: 0;

  width: 100%;
  height: 2px;
}

.results a {
  background-color: transparent;
  padding-top: 0.5em;
}
.results a:not(:first-child, :last-child) {
  aspect-ratio: 1;
  border-radius: 50%;
  width: 36px;
}

.results a:hover,
.results a:focus {
  background-color: #4d2cb9;
  color: white;
}

.results a.active {
  border-style: solid;
  border-color: #4d2cb9;
}
/* Fancy blur effect */
#nprogress .peg {
  display: block;
  position: absolute;
  right: 0px;
  width: 100px;
  height: 100%;
  box-shadow: 0 0 10px #6ffcbc, 0 0 5px #6ffcbc;
  opacity: 1;

  -webkit-transform: rotate(3deg) translate(0px, -4px);
  -ms-transform: rotate(3deg) translate(0px, -4px);
  transform: rotate(3deg) translate(0px, -4px);
}

ul ::-webkit-input-placeholder {
  /* WebKit browsers */
  color: transparent;
}
ul :-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: transparent;
}
ul ::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: transparent;
}
ul :-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: transparent;
}
ul input::placeholder {
  color: transparent;
}

.vuedl-layout__closeBtn {
  display: none;
}
</style>
